import { buildProductUrl } from 'lib/product';
import { useRouter } from 'next/router';
import React, { ReactElement } from 'react';
import Link from '../Link';

export default function VariantButton({
  uid,
  sku,
  name,
  color,
  disableLink,
  current,
  onClick,
}: {
  uid: string | number;
  sku: string;
  name: string;
  color?: string;
  disableLink?: boolean;
  current?: boolean;
  onClick?: () => void;
}): ReactElement {
  const router = useRouter();
  const slug = buildProductUrl(name, color, uid, sku);
  const ariaLabel = `${current ? `${color} frames - currently selected` : `view ${color} frames`}`;

  const src = color === '#N/A' ? 'Black' : color?.replace(' ', '');
  const classes = `rounded-full inline-block p-1 mr-1 border-black ${
    router.asPath.includes(sku) || current ? 'border' : ''
  }`;

  const Image = ({ classes }: { classes?: string }): ReactElement => (
    <img src={`/images/colors/${src}.svg`} alt={`${color}`} className={classes} />
  );

  return (
    <li aria-label={ariaLabel} className="list-none">
      {disableLink ? (
        <button onClick={onClick}>
          <Image classes={classes} />
        </button>
      ) : (
        <Link slug={slug}>
          <a className={classes} aria-label={`View ${color} frames`}>
            <Image />
          </a>
        </Link>
      )}
    </li>
  );
}
